module.exports = "<div class=\"pageContent paddingLight\">\n  <h2>{{'error.' + $ctrl.errorCode | translate}}</h2>\n  <p class=\"txtCenter imageError\">\n    <img class=\"sizeAjust\" src=\"img/photos/gamme.jpg\" width=\"934\" height=\"526\" alt=\"Gamme Renault\" />\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/error/error.html
// module id = 759
// module chunks = 0